/* import __COLOCATED_TEMPLATE__ from './company-notes.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();